import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TicketAPI } from '@base/api/ticket-api';
import type { FieldTicketRequest, CreateTicketResponse } from '@core/types/ticket';

const ticketAPI = new TicketAPI();

export function useCreateTicket() {
  const queryClient = useQueryClient();

  const mutation = useMutation<CreateTicketResponse, Error, FieldTicketRequest>({
    mutationFn: (ticket) => ticketAPI.createTicket(ticket),
    onSuccess: (_, ticket) => {
      // Invalidate ticket list cache
      queryClient.invalidateQueries({ queryKey: ['tickets', ticket.ticket_id_external] });
    },
  });

  return {
    createTicket: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    data: mutation.data,
  };
}
